import { GenericCell } from '@components/design/migrated/Table';
import { ProductsCellClassType, ProductsCompareKpi, ProductsCompareKpiItem } from '@models/Products';
import ProductsTableDataCell from '@components/top-selling-products/products-table-data-cell/ProductsTableDataCell';
import ProductsTableGenericCell from '@components/top-selling-products/products-table-generic-cell/ProductsTableGenericCell';
import ProductsTableRankCell from '@components/top-selling-products/products-table-rank-cell/ProductsTableRankCell';
import * as tableStyles from '@components/top-selling-products/ProductsTable.module.scss';
import {
  ProductsCompareDataRowHeader,
  ProductsCompareDataRowHeaderName,
  ProductsCompareHeaderTitle,
} from '@components/products-compare-modal/Types';
import { isRank } from '@components/products-compare-modal/utils/ProductsModelCompareUtils';
import ProductsCompareModalHeaderRow from '../products-compare-modal-header-row/ProductsCompareModalHeaderRow';
import ProductsCompareModalKpiCell from '../products-compare-modal-kpi-cell/ProductsCompareModalKpiCell';
import useCompareProductsState from '@pages/products-compare/UseCompareProductsState';
import { isPeriodYTDOrMAT } from '@utils/PeriodUtils';

interface Props {
  productsCompareKpi: ProductsCompareKpi;
  currency: string;
  headerOffset: number;
}

const renderDataCell = (
  headerKey: ProductsCompareDataRowHeader,
  kpiItem: ProductsCompareKpiItem,
  currency: string,
  isYtdMat: boolean,
) => {
  const data = kpiItem[headerKey];
  if (!data) {
    return <GenericCell alignment="right" primary="" />;
  }
  if (isRank(data)) {
    return <ProductsTableRankCell ranking={data} />;
  }
  return (
    <ProductsTableDataCell
      headerKey={headerKey}
      cellContent={kpiItem}
      currency={currency}
      isHideSecondaryCell={isYtdMat}
    />
  );
};

const ProductsCompareModalDataRows: React.FC<Props> = ({
  productsCompareKpi,
  currency,
  // offsets its top position when stickied to top
  // useful when something else is stickied above it and you don't want them to overlap
  headerOffset,
}) => {
  const { selectedPeriod } = useCompareProductsState();

  return (
    <>
      <ProductsCompareModalHeaderRow title={ProductsCompareHeaderTitle.DATA} headerOffset={headerOffset} />
      {Object.keys(ProductsCompareDataRowHeaderName).map((headerKey) => {
        const headerKeyWithType: ProductsCompareDataRowHeader = headerKey as ProductsCompareDataRowHeader;
        return (
          <tr key={headerKeyWithType} className={tableStyles.ProductsTable__TableRow__WithHover}>
            <ProductsCompareModalKpiCell headerName={ProductsCompareDataRowHeaderName[headerKeyWithType]} />
            {productsCompareKpi.items.map((kpiItem) => (
              <ProductsTableGenericCell
                key={`${headerKeyWithType}_Cell_${kpiItem.item.itemId}`}
                cellKey={`${headerKeyWithType}_Cell_${kpiItem.item.itemId}`}
                classType={ProductsCellClassType.FEATURE}
              >
                {renderDataCell(headerKeyWithType, kpiItem, currency, isPeriodYTDOrMAT(selectedPeriod))}
              </ProductsTableGenericCell>
            ))}
          </tr>
        );
      })}
    </>
  );
};

export default ProductsCompareModalDataRows;
